import BasePresenter from "../../redare/presenter/BasePresenter";
import * as ApplicationHttp from "../http/ApplicationHttp";

/**
 * Created by RdevPlugins.JsPresenterBuilderAction on 2021-11-23 10:13:03.
 */

export default class ApplicationPresenter extends BasePresenter {

    /**
     * @param body: {sysCode, key, name, icon, userId, classify, isShowApp, isShowPC}
     * @param query: {curPage,pageSize}
     * @returns Promise
     */
    findApplicationPage(body, query, success, fails) {

        if (this._onBeforeFindApplicationPage) {
            let data = this._onBeforeFindApplicationPage(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        ApplicationHttp.findApplicationPage(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindApplicationPageSuccess) {
                    result = this._onBeforeFindApplicationPageSuccess(result, { body, query });
                }

                if (this.view && this.view._onFindApplicationPageSuccess) {
                    this.view._onFindApplicationPageSuccess(result, { body, query });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {sysCode, key, name, icon, userId, classify, isShowApp, isShowPC}
     * @param query: {curPage,pageSize}
     * @returns Promise
     */
    findApplicationPageList(body, query, success, fails) {

        if (this._onBeforeFindApplicationPageList) {
            let data = this._onBeforeFindApplicationPageList(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        ApplicationHttp.findApplicationPageList(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindApplicationPageListSuccess) {
                    result = this._onBeforeFindApplicationPageListSuccess(result, { body, query });
                }

                if (this.view && this.view._onFindApplicationPageListSuccess) {
                    this.view._onFindApplicationPageListSuccess(result, { body, query });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {sysCode, key, name, icon, userId, classify, isShowApp, isShowPC}
     * @param query: {}
     * @returns Promise
     */
    findApplicationList(body, query, success, fails) {

        if (this._onBeforeFindApplicationList) {
            let data = this._onBeforeFindApplicationList(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        ApplicationHttp.findApplicationList(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindApplicationListSuccess) {
                    result = this._onBeforeFindApplicationListSuccess(result, { body, query });
                }

                if (this.view && this.view._onFindApplicationListSuccess) {
                    this.view._onFindApplicationListSuccess(result, { body, query });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {id}
     * @param query: {}
     * @returns Promise
     */
    getApplication(body, query, success, fails) {

        if (this._onBeforeGetApplication) {
            let data = this._onBeforeGetApplication(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        ApplicationHttp.getApplication(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeGetApplicationSuccess) {
                    result = this._onBeforeGetApplicationSuccess(result, { body, query });
                }

                if (this.view && this.view._onGetApplicationSuccess) {
                    this.view._onGetApplicationSuccess(result, { body, query });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {sysCode, name, icon, classify, accessCode, accessKey, appAccessUrl, appAccessHeadParam, appAccessBodyParam, verifyUrl, verifyHeadParam, verifyBodyParam, verifyResponseParam, gtasksUrl, gtasksHeadParam, gtasksBodyParam, remark, roleIds, roleIdList, roleNames, createTime, sort, showApp, showPage, pageUrl, status, appPage, isShowApp, orgIds, orgNames, orgIdList, isShowPC, verifyAccountAndPwd, pcRoleIds, pcOrgIds, pcRoleIdList, pcOrgIdList}
     * @param query: {}
     * @returns Promise
     */
    addApplication(body, query, success, fails) {

        if (this._onBeforeAddApplication) {
            let data = this._onBeforeAddApplication(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        ApplicationHttp.addApplication(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeAddApplicationSuccess) {
                    result = this._onBeforeAddApplicationSuccess(result, { body, query });
                }

                if (this.view && this.view._onAddApplicationSuccess) {
                    this.view._onAddApplicationSuccess(result, { body, query });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {id, sysCode, name, icon, classify, accessCode, accessKey, appAccessUrl, appAccessHeadParam, appAccessBodyParam, verifyUrl, verifyHeadParam, verifyBodyParam, verifyResponseParam, gtasksUrl, gtasksHeadParam, gtasksBodyParam, remark, roleIds, roleIdList, roleNames, createTime, sort, showApp, showPage, pageUrl, status, appPage, isShowApp, orgIds, orgNames, orgIdList, isShowPC, verifyAccountAndPwd, pcRoleIds, pcOrgIds, pcRoleIdList, pcOrgIdList}
     * @param query: {}
     * @returns Promise
     */
    editApplication(body, query, success, fails) {

        if (this._onBeforeEditApplication) {
            let data = this._onBeforeEditApplication(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        ApplicationHttp.editApplication(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeEditApplicationSuccess) {
                    result = this._onBeforeEditApplicationSuccess(result, { body, query });
                }

                if (this.view && this.view._onEditApplicationSuccess) {
                    this.view._onEditApplicationSuccess(result, { body, query });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {id}
     * @param query: {}
     * @returns Promise
     */
    deleteApplication(body, query, success, fails) {

        if (this._onBeforeDeleteApplication) {
            let data = this._onBeforeDeleteApplication(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        ApplicationHttp.deleteApplication(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeDeleteApplicationSuccess) {
                    result = this._onBeforeDeleteApplicationSuccess(result, { body, query });
                }

                if (this.view && this.view._onDeleteApplicationSuccess) {
                    this.view._onDeleteApplicationSuccess(result, { body, query });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {sysCode, key, name, icon, userId, classify, isShowApp, isShowPC}
     * @param query: {}
     * @returns Promise
     */
    findApplicationOfUserList(body, query, success, fails) {

        if (this._onBeforeFindApplicationOfUserList) {
            let data = this._onBeforeFindApplicationOfUserList(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        ApplicationHttp.findApplicationOfUserList(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindApplicationOfUserListSuccess) {
                    result = this._onBeforeFindApplicationOfUserListSuccess(result, { body, query });
                }

                if (this.view && this.view._onFindApplicationOfUserListSuccess) {
                    this.view._onFindApplicationOfUserListSuccess(result, { body, query });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {sysCode, key, name, icon, userId, classify, isShowApp, isShowPC}
     * @param query: {}
     * @returns Promise
     */
    applicationList(body, query, success, fails) {

        if (this._onBeforeFindApplicationOfUserList) {
            let data = this._onBeforeFindApplicationOfUserList(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        ApplicationHttp.applicationList(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindApplicationOfUserListSuccess) {
                    result = this._onBeforeFindApplicationOfUserListSuccess(result, { body, query });
                }

                if (this.view && this.view._onFindApplicationOfUserListSuccess) {
                    this.view._onFindApplicationOfUserListSuccess(result, { body, query });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }


    /**
     * @param body: {sysCode, key, name, icon, userId, classify, isShowApp, isShowPC}
     * @param query: {}
     * @returns Promise
     */
    addApplicationList(body, query, success, fails) {

        if (this._onBeforeFindApplicationOfUserList) {
            let data = this._onBeforeFindApplicationOfUserList(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        ApplicationHttp.addApplicationList(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindApplicationOfUserListSuccess) {
                    result = this._onBeforeFindApplicationOfUserListSuccess(result, { body, query });
                }

                if (this.view && this.view._onFindApplicationOfUserListSuccess) {
                    this.view._onFindApplicationOfUserListSuccess(result, { body, query });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {sysCode, key, name, icon, userId, classify, isShowApp, isShowPC}
     * @param query: {}
     * @returns Promise
     */
    delApplicationList(body, query, success, fails) {

        if (this._onBeforeFindApplicationOfUserList) {
            let data = this._onBeforeFindApplicationOfUserList(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        ApplicationHttp.delApplicationList(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindApplicationOfUserListSuccess) {
                    result = this._onBeforeFindApplicationOfUserListSuccess(result, { body, query });
                }

                if (this.view && this.view._onFindApplicationOfUserListSuccess) {
                    this.view._onFindApplicationOfUserListSuccess(result, { body, query });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }
}